import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { inViewport } from '../../shared/util';
import { MediaQuery as MQ } from '../../shared/media-query';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.requirePsychics();

        this.scrollListener = _.throttle(this.trackViewPromotion, 100);

        this.state = {
            view_promotion_sent: false,
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.psychics != this.props.psychics) {
            return true;
        }

        return false;
    }

    componentDidUpdate() {
        this.trackViewPromotion();
    }

    render({ psychics }) {
        if (psychics && Object.keys(psychics).length) {
            window.addEventListener('scroll', this.scrollListener);

            return (
                <keen-slider>
                    <row className='is-wrap is-aligned-center has-margin-20-bottom has-margin-10-left-mobile'>
                        <column className='is-8 is-12-mobile'>
                            <h2 className='has-margin-10-bottom has-weight-400'>Get Psychic Advice Now</h2>
                        </column>
                    </row>
                    <row className='is-wrap keen-carousel has-margin-10-left-mobile'>
                        {Object.keys(psychics).map(key => this.renderPsychic(psychics[key]))}
                        <img onclick={(e) => carouselRotate(e)} class="keen-carousel-nav" src="https://gfx.tarot.com/images/home/more-arrow.svg" loading="lazy" height="56" width="30" alt="more-arrow" />
                    </row>
                </keen-slider>
            );
        }

        return (<keen-slider />);
    }

    renderPsychic = (psychic) => {
        return (
            <a
                href={psychic.slider_link}
                target='_blank'
                rel='noopener sponsored noreferrer'
                onClick={() => this.props.trackEvent([
                    'Click',
                    `Psychics_Slider:${psychic.id}_Card`,
                ])}
                className='psychic-slider'
            >
                <column>
                    <row className='is-wrap'>
                        <column className='is-12 has-text-center'>
                            <img src={psychic.img} />
                        </column>
                        <column className='is-8 is-7-mobile has-margin-20-left'>
                            <p className='has-margin-5-bottom'>
                                Exceptional
                            </p>
                            <div className='is-flex'>
                                {[0, 1, 2, 3, 4].map(() => (
                                    <img
                                        width='20'
                                        height='auto'
                                        src='https://gfx.tarot.com/images/site/tarot/psychics/star.svg'
                                        alt='Keen Psychic Rating Stars'
                                    />
                                ))}
                            </div>
                        </column>
                        <column className='is-3 has-margin-15-top has-margin-5-top-mobile'>
                            <span className='psychic-score-slider'>
                                {psychic.rating}
                            </span>
                        </column>
                        <column className='is-12 psychic-body-slider'>
                            <h5>
                                {psychic.header}
                            </h5>
                            <ul>
                                {psychic.bullet_points.map(bullet => (
                                    <li>
                                        {bullet}
                                    </li>
                                ))}
                            </ul>
                        </column>
                        <column className='is-12 psychic-button-slider'>
                            <a className='button button-purple is-pill'>{MQ.isMobile() && psychic.id == 'PsychicSource' ? 'Chat Now' : 'Start Now'}</a>
                        </column>
                    </row>
                </column>
            </a>
        );
    }

    trackViewPromotion = () => {
        if (
            !this.state.view_promotion_sent
            &&
            this.props.psychics
            &&
            inViewport('keen-slider', true)
        ) {
            window.removeEventListener('scroll', this.scrollListener);

            this.setState({
                view_promotion_sent: true,
            });

            this.props.trackViewPromotion({
                placement: 'keen-slider',
                id: 'Keen-API',
                name: 'Psychics_Slider:KeenAPI',
            });
        }
    }
}

const mapStateToProps = (state) => ({
    psychics: state.keen,
});

const mapDispatchToProps = (dispatch) => ({
    requirePsychics: () => dispatch({
        type: 'keen:init',
        payload: {
            size: 2,
        },
    }),
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
    trackViewPromotion: (payload) => dispatch({
        type: 'ga:view_promotion',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
